import { useEffect, useRef, useState } from "react";
import { quoteLangs, quotes, type QuoteLang } from "../../data/quotes";
import { SectionShell } from "../layout/SectionShell";
import styles from "./Sounds.module.css";

export function Sounds() {
  const [lang, setLang] = useState<QuoteLang>("en");
  const playing = useRef<HTMLAudioElement | null>(null);
  const [clip, setClip] = useState<string | null>(null);

  useEffect(() => {
    return () => {
      playing.current?.pause();
      playing.current = null;
    };
  }, []);

  const play = (src: string, key: string) => {
    playing.current?.pause();
    const audio = new Audio(src);
    playing.current = audio;
    setClip(key);
    audio.addEventListener("ended", () => {
      if (playing.current === audio) {
        playing.current = null;
        setClip(null);
      }
    });
    void audio.play().catch(() => setClip(null));
  };

  return (
    <SectionShell id="sounds" kicker="Voicelines" title="Sounds of Mondragón">
      <div className={styles.tabs} role="tablist" aria-label="Quote language">
        {quoteLangs.map((item) => (
          <button
            key={item.id}
            type="button"
            role="tab"
            className={styles.tab}
            aria-selected={lang === item.id}
            onClick={() => {
              playing.current?.pause();
              playing.current = null;
              setClip(null);
              setLang(item.id);
            }}
          >
            {item.label}
          </button>
        ))}
      </div>
      <ul className={styles.list}>
        {quotes.map((line) => {
          const text = line.text[lang];
          const src = line.voice?.[lang];
          if (!text) return null;
          return (
            <li key={line.key} className={styles.row}>
              <span className={styles.label}>{line.label}</span>
              <p>{text}</p>
              {src ? (
                <button
                  type="button"
                  className={styles.play}
                  aria-pressed={clip === line.key}
                  onClick={() => play(src, line.key)}
                >
                  {clip === line.key ? "Playing" : "Play"}
                </button>
              ) : null}
            </li>
          );
        })}
      </ul>
    </SectionShell>
  );
}
